import React, { useEffect, useState } from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import ContenuLibre from "../../components/ContenuLibre/contenu-libre"
import {
  listEventsContainer,
  listEvents,
  eventsContainer,
  eventsItem,
  eventsItemContainer,
  zoneEventsLibreHaut,
  zoneEventsLibreBas,
  eventsFilters,
  eventsFilterByPeriod,
  eventsFilterByTaxo,
  eventsFiltersTaxo,
  eventsFiltersTaxoActive,
  vocalizedUpdate,
  tabHidden,
} from "./styles/listEvents.module.scss"
import PropTypes from "prop-types"
import {
  ContainerLight,
  EventsItem,
  BorderTaxo,
  StyledFade,
  EventsPeriodFilter,
  EventsPeriodFilterContainer,
} from "./styled-components/evenements-styled"
import SEO from "../../components/seo"
import EvenementItem from "./listItems/evenement-item"
import { getExistingTaxosInItems } from "./utils/get-existing-taxos-in-items"
import { getPublishedData } from "../../components/get-published-data"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query {
    allNodeEvenements(sort: { fields: field_date_de_debut, order: DESC }) {
      ...ListEvents
    }
  }
`
//-----------------------QueryGraphql---------------------------//

//-----------------------Parent component---------------------------//

const EvenementsTemplate = ({ data }) => {
  const [publishedData, setPublishedData] = useState([])
  const pageTitle = "Liste des évènements"
  const relatedTaxos =
    publishedData.length > 0
      ? getExistingTaxosInItems(publishedData).join()
      : []

  useEffect(() => {
    setPublishedData(getPublishedData(data.allNodeEvenements.edges))
  }, [data])

  return (
    <Layout message={pageTitle}>
      <SEO
        title={pageTitle}
        description={
          "Dans cette page, vous découvrez tous les évènements, mais aussi l'ensemble des thématiques suivantes : " +
          relatedTaxos
        }
      />
      <StyledFade childClassName={listEvents} delay={150}>
        <section className={zoneEventsLibreHaut}>
          <ContenuLibre zoneTaxoLibre="zone_evenements_haut" />
        </section>
        <Filtres eventsData={data} />
        <ContainerLight className={zoneEventsLibreBas}>
          <ContenuLibre zoneTaxoLibre="zone_evenements_bas" />
        </ContainerLight>
      </StyledFade>
    </Layout>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const Filtres = ({ eventsData }) => {
  const [publishedData, setPublishedData] = useState([])

  useEffect(() => {
    setPublishedData(getPublishedData(eventsData.allNodeEvenements.edges))
  }, [eventsData])

  const relatedTaxos =
    publishedData.length > 0 ? getExistingTaxosInItems(publishedData) : []
  const [chooseTaxo, setChooseTaxo] = useState("")
  return (
    <>
      <ContainerLight className={eventsFilters}>
        <div className={eventsFilterByTaxo}>
          <h3>Thématique : </h3>
          <ul>
            {relatedTaxos.map((element, index) => {
              let taxoActiveClass = false
              if (chooseTaxo === element) {
                taxoActiveClass = true
              }
              return (
                <li key={index}>
                  <BorderTaxo
                    activeBool={taxoActiveClass}
                    activeText={"#fff"}
                    tabIndex={0}
                    role="button"
                    aria-label={
                      taxoActiveClass
                        ? element + " - Supprimer le filtre actif"
                        : "Filtrer sur la taxonomie '" + element + "'"
                    }
                    className={
                      taxoActiveClass
                        ? eventsFiltersTaxoActive
                        : eventsFiltersTaxo
                    }
                    onClick={() => {
                      if (chooseTaxo === "" || chooseTaxo !== element) {
                        setChooseTaxo(element)
                      } else if (chooseTaxo === element) {
                        setChooseTaxo("")
                      }
                    }}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        if (chooseTaxo === "" || chooseTaxo !== element) {
                          setChooseTaxo(element)
                        } else if (chooseTaxo === element) {
                          setChooseTaxo("")
                        }
                      }
                    }}
                  >
                    {element}
                  </BorderTaxo>
                </li>
              )
            })}
          </ul>
        </div>
      </ContainerLight>
      <FiltreEvenement eventsData={publishedData} taxoChoisie={chooseTaxo} />
    </>
  )
}

//-----------------------Child component---------------------------//

//-----------------------Sub-Child component---------------------------//

const FiltreEvenement = ({ eventsData, taxoChoisie }) => {
  const [numberOfItems, setNumberOfItems] = useState(6)
  const [eventsPeriod, setEventsPeriod] = useState("incoming")
  let filteredData = []
  filteredData = eventsData.reduce((acc, node) => {
    let matchingTaxo = []
    matchingTaxo = node.node.relationships.field_taxonomie_thematique.filter(
      (taxo) => taxo.name === taxoChoisie
    )
    if (matchingTaxo.length > 0) {
      acc.push(node)
    }
    return acc
  }, [])
  const now = new Date()
  filteredData = taxoChoisie === "" ? eventsData : filteredData
  let finalFilteredData = undefined
  let othersData = undefined
  const incomingEvents = filteredData
    .filter(({ node }) => {
      if (node.fields.formatted_for_compare_field_date_de_fin) {
        if (
          new Date(node.fields.formatted_for_compare_field_date_de_fin) >= now
        ) {
          return true
        }
      } else if (
        new Date(
          node.fields.formatted_for_compare_field_date_de_debut
        ).setHours(0, 0, 0, 0) > now.setHours(0, 0, 0, 0)
      ) {
        return true
      }
      return false
    })
    .sort((firstDate, lastDate) => {
      if (
        firstDate.node.fields.formatted_for_compare_field_date_de_debut >
        lastDate.node.fields.formatted_for_compare_field_date_de_debut
      )
        return 1
      if (
        firstDate.node.fields.formatted_for_compare_field_date_de_debut <
        lastDate.node.fields.formatted_for_compare_field_date_de_debut
      )
        return -1
      return 0
    })
  const inProgressEvents = filteredData.filter(({ node }) => {
    if (node.fields.formatted_for_compare_field_date_de_fin) {
      if (
        new Date(
          node.fields.formatted_for_compare_field_date_de_debut
        ).setHours(0, 0, 0, 0) <= now.setHours(0, 0, 0, 0) &&
        new Date(node.fields.formatted_for_compare_field_date_de_fin).setHours(
          0,
          0,
          0,
          0
        ) >= now.setHours(0, 0, 0, 0)
      ) {
        return true
      }
    } else if (
      new Date(node.fields.formatted_for_compare_field_date_de_debut).setHours(
        0,
        0,
        0,
        0
      ) === now.setHours(0, 0, 0, 0)
    ) {
      return true
    }
    return false
  })
  const pastEvents = filteredData.filter(({ node }) => {
    if (node.fields.formatted_for_compare_field_date_de_fin) {
      if (
        new Date(node.fields.formatted_for_compare_field_date_de_fin) <= now
      ) {
        return true
      }
    } else if (
      new Date(node.fields.formatted_for_compare_field_date_de_debut).setHours(
        0,
        0,
        0,
        0
      ) < now.setHours(0, 0, 0, 0)
    ) {
      return true
    }

    return false
  })
  switch (eventsPeriod) {
    case "incoming":
      finalFilteredData = incomingEvents.slice(0, numberOfItems)
      othersData = incomingEvents.slice(numberOfItems)
      break
    case "inprogress":
      finalFilteredData = inProgressEvents.slice(0, numberOfItems)
      othersData = inProgressEvents.slice(numberOfItems)
      break
    case "past":
      finalFilteredData = pastEvents.slice(0, numberOfItems)
      othersData = pastEvents.slice(numberOfItems)
      break
    default:
      finalFilteredData = filteredData.slice(0, numberOfItems)
      othersData = filteredData.slice(numberOfItems)
      break
  }
  const tabPeriod = [
    {
      incoming: "A venir",
    },
    {
      inprogress: "En cours",
    },
    {
      past: "Passés",
    },
  ]
  return (
    <>
      <section className={listEventsContainer}>
        <div className={eventsContainer}>
          <EventsPeriodFilterContainer
            className={eventsFilterByPeriod}
            role="tablist"
            aria-label="Sélection de la période"
          >
            {tabPeriod.map((element, index) => {
              const propertyName = Object.getOwnPropertyNames(element)[0]
              const value = element[propertyName]
              return (
                <EventsPeriodFilter
                  key={index}
                  aria-controls={"tabpanel-" + propertyName}
                  id={"tab-" + propertyName}
                  active={eventsPeriod === propertyName}
                  tabIndex="0"
                  role="tab"
                  aria-selected={eventsPeriod === propertyName}
                  onClick={() => {
                    if (eventsPeriod !== propertyName) {
                      setEventsPeriod(propertyName)
                    }
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      if (eventsPeriod !== propertyName) {
                        setEventsPeriod(propertyName)
                      }
                    }
                  }}
                >
                  {value}
                </EventsPeriodFilter>
              )
            })}
          </EventsPeriodFilterContainer>
          <p className={vocalizedUpdate} role="status" aria-live="polite">
            {finalFilteredData.length > 0
              ? finalFilteredData.length +
                " événement" +
                (finalFilteredData.length === 1 ? "" : "s") +
                " affiché" +
                (finalFilteredData.length === 1 ? "" : "s")
              : "Aucun événement affiché"}
          </p>
          <RenderEvenements
            taxoChoisie={taxoChoisie}
            filteredData={finalFilteredData}
            eventsPeriod={eventsPeriod}
            tabPeriod={tabPeriod}
          />
        </div>
        {othersData.length > 0 && (
          <div className="voirPlus">
            <span
              role="button"
              tabIndex={0}
              onClick={() => setNumberOfItems(numberOfItems + 6)}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  setNumberOfItems(numberOfItems + 6)
                }
              }}
              className="btn"
            >
              Voir plus
            </span>
          </div>
        )}
      </section>
    </>
  )
}

//-----------------------Sub-Child component---------------------------//

//-----------------------Sub-Sub-Child component---------------------------//

const RenderEvenements = ({
  filteredData,
  taxoChoisie,
  tabPeriod,
  eventsPeriod,
}) => {
  return (
    <>
      {tabPeriod.map((element, index) => {
        const propertyName = Object.getOwnPropertyNames(element)[0]
        const classes = `${eventsItemContainer} ${
          propertyName !== eventsPeriod ? tabHidden : ""
        }`
        return (
          <ul
            key={index}
            className={classes}
            id={"tabpanel-" + propertyName}
            role="tabpanel"
            aria-labelledby={"tab-" + propertyName}
          >
            {filteredData.length === 0 && (
              <p style={{ margin: "0 2rem" }}>Pas de contenu à afficher.</p>
            )}
            {filteredData.map(({ node }) => (
              <EventsItem key={node.title} className={eventsItem}>
                <EvenementItem taxoChoisie={taxoChoisie} evenement={node} />
              </EventsItem>
            ))}
          </ul>
        )
      })}
    </>
  )
}

//-----------------------Sub-Sub-Child component---------------------------//

//-----------------------Prop-Types---------------------------//

EvenementsTemplate.propTypes = {
  data: PropTypes.object.isRequired,
}
RenderEvenements.propTypes = {
  filteredData: PropTypes.array.isRequired,
  taxoChoisie: PropTypes.string.isRequired,
  eventsPeriod: PropTypes.string.isRequired,
  tabPeriod: PropTypes.array.isRequired,
}
FiltreEvenement.propTypes = {
  eventsData: PropTypes.object.isRequired,
  taxoChoisie: PropTypes.string.isRequired,
}
Filtres.propTypes = {
  eventsData: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default EvenementsTemplate
